module.exports = __webpack_public_path__ + "img/position_FB.d636845c.png";